import { FaLinkedin } from "react-icons/fa";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { TbPhoneCheck } from "react-icons/tb";
import Pagination from "../../../Components/formModules/Pagination";
import { useDispatch } from "react-redux";
import { getMobileAccessStart } from "../../../Store/Slices/scrapperSlice";
import { formatLabel } from "../../../Components/DateFn";
import { IoMdRefresh } from "react-icons/io";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";

const PhoneCell = ({ phoneNo, onRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [timerFinished, setTimerFinished] = useState(false);

    const startTimer = () => {
        setLoading(true);
        setTimerFinished(false);

        const timer = setTimeout(() => {
            setLoading(false);
            setTimerFinished(true);
        }, 3 * 60 * 1000); // 3 * 60 * 1000

        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (!phoneNo) {
            const cleanup = startTimer();
            return cleanup;
        }
    }, [phoneNo]);

    const handleRefresh = async () => {
        setLoading(true);
        setTimerFinished(false);

        await onRefresh();

        if (!phoneNo) {
            startTimer();
        }
    };

    if (phoneNo) {
        return <span>{phoneNo}</span>;
    }

    if (loading) {
        return (
            <>
                <div className="text-blue-600">
                    Requested for phone no.
                </div>
                <div className="text-blue-600">
                    Please wait for few minutes
                </div>
            </>
        );
    }

    if (timerFinished) {
        return (
            <div>
                <span className="text-red-600">Phone no not available</span>{" "}
                <button
                    onClick={handleRefresh}
                    className="ml-2 border bg-gray-200 rounded hover:bg-gray-300"
                >
                    <IoMdRefresh />
                </button>
            </div>
        );
    }

    return null;
};

const SavedTableData = ({ savedData, setSelectedDataToUnsave, selectedDataToUnsave,
    currentPageS, setCurrentPageS, pageSizeS, setPageSizeS, setPaginationActivateS,
    totalSavedCount, accessDataList, error
}) => {
    const dispatch = useDispatch();
    const selectAllRef = useRef(null);

    const handleUnsaveFilterData = (e, row) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedDataToUnsave(prev => {
                const exists = prev.some(item => item._id === row._id);
                return exists ? prev : [...prev, row];
            });
        } else {
            setSelectedDataToUnsave(prev =>
                prev.filter(item => item._id !== row._id)
            );
        }
    }

    const handlePageSizeChange = (size) => {
        setPaginationActivateS(true);
        setPageSizeS(size);
        setCurrentPageS(1);
    };

    const handlePrevPage = () => {
        setPaginationActivateS(true);
        setCurrentPageS((prev) => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setPaginationActivateS(true);
        let totalPages = Math.ceil(totalSavedCount / pageSizeS);
        setCurrentPageS((prev) => Math.min(prev + 1, totalPages));
    };

    const getAccessMobile = (row) => {
        let payload = {
            data: [{
                "first_name": row?.first_name,
                "last_name": row?.last_name,
                "organization_name": row?.organization?.name,
                "person_id": row?.person_id
            }]
        }
        dispatch(getMobileAccessStart(payload))
    }

    useEffect(() => {
        if (error) {
            toast.error(error, {
                autoClose: 2000
            });
        }
    }, [error])

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedDataToUnsave(savedData); // store full objects
        } else {
            setSelectedDataToUnsave([]);
        }
    };

    useEffect(() => {
        if (selectAllRef.current) {
            selectAllRef.current.indeterminate =
                selectedDataToUnsave?.length > 0 && selectedDataToUnsave?.length < savedData?.length;
        }
    }, [selectedDataToUnsave, savedData?.length]);

    const isAllSelected = selectedDataToUnsave?.length === savedData?.length && savedData?.length > 0;

    return (
        <>
            <Toast />
            <div className="tbl-container rounded-table mt-2">
                <div className="table-responsive">
                    <table className="table table-hover hover-icon-table users-table mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input" type="checkbox"
                                        ref={selectAllRef}
                                        checked={isAllSelected}
                                        onChange={(e) => handleSelectAll(e)} />
                                </th>
                                <th className="w-30">Name</th>
                                <th className="w-30">Job Title</th>
                                <th className="w-20">Company</th>
                                <th className="w-30">Emails</th>
                                <th className="w-30">Phone</th>
                                {/* <th className="w-30">Link</th> */}
                                <th className="w-30">Location</th>
                                <th className="w-30">Industry</th>
                                <th className="w-30">Keywords</th>
                            </tr>
                        </thead>
                        <tbody>
                            {savedData?.length > 0 ?
                                <>
                                    {savedData?.map((data, index) => {
                                        const match = accessDataList?.find(item => item.person_id === data.person_id);
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <input className="form-check-input" type="checkbox"
                                                        checked={selectedDataToUnsave?.some(item => item._id === data._id)}
                                                        onChange={(e) => handleUnsaveFilterData(e, data)}
                                                    />
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.first_name} {data?.last_name}</div>
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.title}</div>
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.organization?.name}</div>
                                                </td>
                                                <td className="w-30">
                                                    {match ?
                                                        <div>{match?.email}</div>
                                                        : <button class="btn btn-light btn-blue me-2 border" type="button"
                                                            onClick={() => getAccessMobile(data)}
                                                        >
                                                            <MdOutlineMarkEmailRead className="me-1" />
                                                            Access Email</button>
                                                    }
                                                </td>
                                                <td className="w-30">
                                                    {match ?
                                                        <>
                                                            <PhoneCell
                                                                phoneNo={match?.phone}
                                                                onRefresh={() => getAccessMobile(data)}
                                                            />
                                                            {/* {match?.phone ?
                                                                <div>{match?.phone}</div>
                                                                : <>
                                                                    <div>Requested for phone no</div>
                                                                    <div>Please wait for few minutes</div>
                                                                </>
                                                            } */}
                                                        </>
                                                        : <button class="btn btn-light btn-blue me-2 border" type="button"
                                                            onClick={() => getAccessMobile(data)}
                                                        >
                                                            <TbPhoneCheck className="me-1" />
                                                            Access Mobile</button>
                                                    }
                                                </td>
                                                {/* <td className="w-30">
                                                    <FaLinkedin title={data?.linkedin_url} />
                                                </td> */}
                                                <td className="w-30">
                                                    {/* <div>{data?.city} {data?.state} {data?.country}</div> */}
                                                    <div>{[data.city, data.state, data.country].filter(Boolean).join(', ')}</div>
                                                </td>
                                                <td className="w-30">
                                                    {data?.departments?.map((x) => (
                                                        <span className="dhub-table">{formatLabel(x)}</span>
                                                    ))}
                                                </td>
                                                <td className="w-30">
                                                    {data?.subdepartments?.map((x) => (
                                                        <span className="dhub-table">{formatLabel(x)}</span>
                                                    ))}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </>
                                :
                                <tr>
                                    <td colSpan={7} className='text-center'>No Data Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <div className="datavault-pagination">
                        <div className="ag-theme-quartz" style={{ height: "auto", display: "flex", flexDirection: "column", position: "relative" }}>
                            <Pagination
                                className="border-0"
                                currentPage={currentPageS}
                                pageSize={pageSizeS}
                                totalCount={totalSavedCount}
                                onPageSizeChange={handlePageSizeChange}
                                onPrevPage={handlePrevPage}
                                onNextPage={handleNextPage}
                            />
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default SavedTableData;